module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-iap_4252d14.png";